// extracted by mini-css-extract-plugin
export default {"col":"Table_col__FlucW","row":"Table_row__z+C35","wrap":"Table_wrap__Pk9fZ"};